import { html, css } from 'lit';
import { Styles } from '../types/types';
import OlComponent from './OlComponent';

export default class FontSizeComponent extends OlComponent {
    onClick: (value: Styles["font-size"]) => void;
    constructor(onClick: (value: Styles["font-size"]) => void) {
        super();
        this.onClick = onClick;
    }

    override styles = css`
    .vrange {
        appearance: slider-vertical;
        -webkit-appearance: slider-vertical;
        width: 100%;
        height: 100%;
        background: #d3d3d3;
        opacity: 0.7;
        -webkit-transition: .2s; /* 0.2 seconds transition on hover */
        transition: opacity .2s;
    }

    .vrange:hover {
        opacity: 0.75;
    }

    .fs-buttons button {
        border-radius: 20px;
        border: none;
    }
    .fs-buttons button:hover {
        box-shadow: 2px 2px 3px 2px rgba(0,0,0,.1);
        opacity: 1;
    }
`

    override render() {
        return (
            html`
            <style>${this.styles}</style>
            <div class="fs-buttons container">
                <! –– TODO: Make slider work -- >
                <input type="range" min="10" max="400" value="100" class="vrange" @input=${()=> {}}>
                <button @click=${() => this.onClick("1em")} part="button">1x</button>
                <button @click=${() => this.onClick("2em")} part="button">2x</button>
                <button @click=${() => this.onClick("3em")} part="button">3x</button>
                <button @click=${() => this.onClick("4em")} part="button">4x</button>
                <button @click=${() => this.onClick("10%")} part="button">10%</button>
                <button @click=${() => this.onClick("25%")} part="button">25%</button>
                <button @click=${() => this.onClick("50%")} part="button">50%</button>
                <button @click=${() => this.onClick("75%")} part="button">75%</button>
                <button @click=${() => this.onClick("100%")} part="button">100%</button>
                <button @click=${() => this.onClick("125%")} part="button">125%</button>
                <button @click=${() => this.onClick("150%")} part="button">150%</button>
                <button @click=${() => this.onClick("200%")} part="button">200%</button>
                <button @click=${() => this.onClick("400%")} part="button">400%</button>
            </div>`
        )
    }
}